import React from 'react';
import photo480 from './images/design/portrait-photo-480.webp';
import photo800 from './images/design/portrait-photo-800.webp';
import photo1180 from './images/design/portrait-photo.webp';

// Cut-out portrait (transparent background), framed like the Figma "Portrait/Youssef (cutout)" component.
// srcSet lets phones download the 480px file instead of the full 1180px one.
// `sizes` should describe the rendered CSS width; `priority` marks the above-the-fold (hero) copy.
const Portrait = ({ style, className = '', sizes = '400px', priority = false }) => (
    <img
        src={photo1180}
        srcSet={`${photo480} 480w, ${photo800} 800w, ${photo1180} 1180w`}
        sizes={sizes}
        alt="Youssef Ben Henda"
        className={`portrait ${className}`}
        style={style}
        width="1180"
        height="1333"
        fetchPriority={priority ? 'high' : undefined}
        loading={priority ? undefined : 'lazy'}
        decoding={priority ? undefined : 'async'}
    />
);

export default Portrait;
